import { render } from "./TheC01ItemFormNotePanelGiftCard.vue?vue&type=template&id=0ea52fff&scoped=true&ts=true"
import script from "./TheC01ItemFormNotePanelGiftCard.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemFormNotePanelGiftCard.vue?vue&type=script&lang=ts"

import "./TheC01ItemFormNotePanelGiftCard.vue?vue&type=style&index=0&id=0ea52fff&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea52fff"]])

export default __exports__